// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgZGF0YS1zdmc9ImNsb3NlIj48cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiNGNDkxMDMiIHN0cm9rZS13aWR0aD0iMi4wNiIgZD0iTTE2IDE2IDQgNE0xNiA0IDQgMTYiLz48L3N2Zz4=", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customGroupsContainer--g9hlF {
  width: 100%;
}

[dir] .customGroupsSection--SaNSQ {
  margin-top: 32px;
  padding-top: 16px;
  border-top: 1px solid #e5e7eb;
}

.customGroupsTitleRow--KFmjc {
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

[dir] .customGroupsTitleRow--KFmjc {
  margin-bottom: 8px;
}

.customGroupsTitle--pjZ49 {
  font-weight: 600;
  color: #222;
}

.infoTooltip--bFwrE {
  display: inline-flex;
  align-items: center;
}

[dir] .infoTooltip--bFwrE {
  cursor: help;
}

[dir=ltr] .infoTooltip--bFwrE {
  margin-left: 6px;
}

[dir=rtl] .infoTooltip--bFwrE {
  margin-right: 6px;
}

.infoIcon--Ja00b {
  width: 17px;
  height: 17px;
}

.addCustomGroupButton--NNfAW {
  color: #fff;
  font-size: 1rem;
  transition: background 0.15s;
  font-weight: 600;
  white-space: normal;
  height: auto !important;
}

[dir] .addCustomGroupButton--NNfAW {
  background: #e6512d;
  border: none;
  border-radius: 999px;
  padding: 8px 22px;
  cursor: pointer;
  margin-bottom: 8px;
  margin-top: 4px;
}

.customGroupsList--R2a_3 {
  list-style: none;
  color: #444;
}

[dir] .customGroupsList--R2a_3 {
  margin: 0;
  padding: 0;
}

.customGroupItem--u8PPK {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

[dir] .customGroupItem--u8PPK {
  padding: 8px;
  margin-bottom: 4px;
  background: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #e9ecef;
}

[dir] .customGroupItem--u8PPK:hover {
  background: #e9ecef;
}

.customGroupName--CLkpU {
  font-size: inherit;
  color: #333;
  flex-grow: 1;
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  transition:
    background 0.15s,
    border 0.15s,
    box-shadow 0.15s; /* align with .squareButton */ /* align with .squareButton */
  font-weight: 500; /* align with .squareButton */
  height: auto !important;
}

[dir] .customGroupName--CLkpU {
  background: #fff;
  border: 1.5px solid #d1d5db;
  padding: 8px 12px;
  cursor: pointer;
  border-radius: 4px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
}

[dir=ltr] .customGroupName--CLkpU {
  text-align: left;
}

[dir=rtl] .customGroupName--CLkpU {
  text-align: right;
}

.customGroupName--CLkpU:hover {
  /* Match hover feel used in LocationPickerMenu buttons */
  /*background: #b5b5b5;*/
  color: #222;
  text-decoration: none;
}

[dir] .customGroupName--CLkpU:hover {
  border: 1.5px solid #343c42;
}

.customGroupName--CLkpU.selected--mZPMz {
  /* Match selected state used for countries/groups in LocationPickerMenu */
  font-weight: bold;
  color: #222; /* space for close icon */
}

[dir] .customGroupName--CLkpU.selected--mZPMz {
  background: #ccced0;
  border: 1.5px solid #343c42;
  border-radius: 4px;
}

[dir=ltr] .customGroupName--CLkpU.selected--mZPMz {
  padding-right: 24px;
}

[dir=rtl] .customGroupName--CLkpU.selected--mZPMz {
  padding-left: 24px;
}

.customGroupName--CLkpU.selected--mZPMz:hover {
  color: #222;
  text-decoration: none;
}

[dir] .customGroupName--CLkpU.selected--mZPMz:hover {
  background: #b5b5b5;
  border-color: #343c42;
}

/* Decorative close (x) like LocationPickerMenu; non-interactive */
.customGroupName--CLkpU.selected--mZPMz::after {
  content: '';
  position: absolute;
  top: 50%;
  width: 18px;
  height: 18px;
  -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  pointer-events: none;
}
[dir] .customGroupName--CLkpU.selected--mZPMz::after {
  transform: translateY(-50%);
  background: rgba(52, 60, 66, 0.5);
}
[dir=ltr] .customGroupName--CLkpU.selected--mZPMz::after {
  right: 6px;
}
[dir=rtl] .customGroupName--CLkpU.selected--mZPMz::after {
  left: 6px;
}

.groupNameText--mxyi6 {
  flex: 1;
  /* Allow long custom group names to wrap similar to .squareText */
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
}

.editIcon--af2l0 {
  width: 16px;
  height: 16px;
  color: #e6512d;
}

.customGroupActions--GOUtZ {
  display: flex;
  gap: 8px;
}

.customGroupEdit--bQzqd,
.customGroupDelete--8dSs4 {
  font-size: 16px;
  opacity: 0.7;
  min-width: 36px;
  min-height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

[dir] .customGroupEdit--bQzqd, [dir] .customGroupDelete--8dSs4 {
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
  border-radius: 4px;
}

.customGroupEdit--bQzqd:hover,
.customGroupDelete--8dSs4:hover {
  opacity: 1;
}

.deleteIcon--wAZ44 {
  width: 18px;
  height: 18px;
  color: #e6512d;
}

.groupFlagPreview--B1mCX {
  display: flex;
  align-items: center;
  position: relative;
}

.previewFlag--EOASZ {
  width: 20px;
  height: 20px;
  -o-object-fit: cover;
     object-fit: cover;
  position: relative;
}

[dir] .previewFlag--EOASZ {
  border-radius: 50%;
  border: 2px solid white;
}

[dir=ltr] .previewFlag--EOASZ {
  margin-left: -8px;
}

[dir=rtl] .previewFlag--EOASZ {
  margin-right: -8px;
}

[dir=ltr] .previewFlag--EOASZ:first-child {
  margin-left: 0;
}

[dir=rtl] .previewFlag--EOASZ:first-child {
  margin-right: 0;
}

.moreCountriesIndicator--XF3Ln {
  font-size: 12px;
  color: #6b7280;
  font-weight: 500;
}

[dir] .moreCountriesIndicator--XF3Ln {
  background: #f3f4f6;
  padding: 2px 6px;
  border-radius: 10px;
  border: 1px solid #d1d5db;
}

[dir=ltr] .moreCountriesIndicator--XF3Ln {
  margin-left: 4px;
}

[dir=rtl] .moreCountriesIndicator--XF3Ln {
  margin-right: 4px;
}

.modal--PDwDq {
  position: fixed;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  box-sizing: border-box;
}

[dir] .modal--PDwDq {
  background: rgba(0, 0, 0, 0.5);
  padding: 16px;
}

[dir=ltr] .modal--PDwDq {
  left: 0;
  right: 0;
}

[dir=rtl] .modal--PDwDq {
  right: 0;
  left: 0;
}

.modalContent--tzRxt {
  max-width: 500px;
  width: 100%;
  max-height: 80vh;
  overflow-y: auto;
  box-sizing: border-box;
}

[dir] .modalContent--tzRxt {
  background: white;
  padding: 24px;
  border-radius: 8px;
}

.confirmBody--J63FU {
  font-size: 16px;
  color: #333;
}

.confirmBody--J63FU p {
  line-height: 1.5;
}

[dir] .confirmBody--J63FU p {
  margin: 0 0 12px 0;
}

.confirmDetails--FWxQw {
  color: #6b7280;
  font-size: 16px;
}

[dir] .confirmDetails--FWxQw {
  margin: 0;
}

.modalHeader--ImTr0 {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

[dir] .modalHeader--ImTr0 {
  margin-bottom: 16px;
}

.modalContent--tzRxt h3 {
  color: #333;
  flex: 1;
}

[dir] .modalContent--tzRxt h3 {
  margin: 0;
}

[dir=ltr] .modalContent--tzRxt h3 {
  padding-right: 8px;
}

[dir=rtl] .modalContent--tzRxt h3 {
  padding-left: 8px;
}

.closeButton--_3jsl {
  display: flex;
  align-items: center;
  justify-content: center;
  transition:
    background-color 0.15s,
    border-color 0.15s;
  width: 40px !important;
  height: 40px !important;
  flex-shrink: 0;
}

[dir] .closeButton--_3jsl {
  background: none;
  border: 1px solid #d1d5db;
  cursor: pointer;
  padding: 8px;
  border-radius: 6px;
}

[dir] .closeButton--_3jsl:hover {
  background-color: #f3f4f6;
  border-color: #9ca3af;
}

.closeIcon--ydjno {
  width: 20px;
  height: 20px;
  color: #6b7280;
}

[dir] .formGroup--CcVPJ {
  margin-bottom: 16px;
}

.formGroup--CcVPJ label {
  display: block;
  font-weight: 600;
  color: #333;
}

[dir] .formGroup--CcVPJ label {
  margin-bottom: 4px;
}

.input--ihMSA {
  width: 100%;
  font-size: 16px;
}

[dir] .input--ihMSA {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.input--ihMSA:focus {
  outline: none;
}

[dir] .input--ihMSA:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.countrySelector--nIjkE {
  max-height: 200px;
  overflow-y: auto;
}

[dir] .countrySelector--nIjkE {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 8px;
  background: #f8f9fa;
}

.countryCheckbox--YTrKj {
  display: flex;
  align-items: center;
  font-size: 16px;
}

[dir] .countryCheckbox--YTrKj {
  padding: 6px 0;
  cursor: pointer;
}

[dir=ltr] .countryCheckbox--YTrKj input {
  margin-right: 8px;
}

[dir=rtl] .countryCheckbox--YTrKj input {
  margin-left: 8px;
}

.countryFlag--fsfUW {
  width: 20px;
  height: 20px;
  -o-object-fit: cover;
     object-fit: cover;
}

[dir] .countryFlag--fsfUW {
  border-radius: 50%;
}

[dir=ltr] .countryFlag--fsfUW {
  margin-right: 8px;
}

[dir=rtl] .countryFlag--fsfUW {
  margin-left: 8px;
}

.countryName--qlB4r {
  flex: 1;
}

[dir] .customGroupSearchWrapper--mhKSi {
  margin-bottom: 12px;
}

.customGroupSearchInput--xsKDt {
  width: 100%;
  font-size: 16px;
  box-sizing: border-box;
}

[dir] .customGroupSearchInput--xsKDt {
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
}

.customGroupSearchInput--xsKDt:focus {
  outline: none;
}

[dir] .customGroupSearchInput--xsKDt:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 2px #dbeafe;
}

.selectedCountries--iZMVT {
  font-size: 16px;
}

[dir] .selectedCountries--iZMVT {
  padding: 12px;
  background: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #dee2e6;
}

.selectedCountriesLabel--cvB8H::after {
  content: ': ';
}

.selectedCountriesPills--E3pxi {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

[dir] .selectedCountriesPills--E3pxi {
  margin-top: 6px;
}

.countryPill--uqZv3 {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #222;
  transition: all 0.15s;
}

[dir] .countryPill--uqZv3 {
  background: #f9fafb;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
}

[dir=ltr] .countryPill--uqZv3 {
  padding: 3px 4px 3px 6px;
}

[dir=rtl] .countryPill--uqZv3 {
  padding: 3px 6px 3px 4px;
}

[dir] .countryPill--uqZv3:hover {
  background: #e5e7eb;
  border-color: #9ca3af;
}

.pillFlag--M0S1i {
  width: 16px;
  height: 16px;
  -o-object-fit: cover;
     object-fit: cover;
}

[dir] .pillFlag--M0S1i {
  border-radius: 50%;
}

[dir=ltr] .pillFlag--M0S1i {
  margin-right: 5px;
}

[dir=rtl] .pillFlag--M0S1i {
  margin-left: 5px;
}

.pillText--KGrAe {
  font-weight: 500;
}

[dir=ltr] .pillText--KGrAe {
  margin-right: 3px;
}

[dir=rtl] .pillText--KGrAe {
  margin-left: 3px;
}

.pillRemove--KYSW5 {
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s;
  color: #6b7280;
}

[dir] .pillRemove--KYSW5 {
  background: none;
  border: none;
  cursor: pointer;
  padding: 1px;
  border-radius: 2px;
}

.pillRemove--KYSW5:hover {
  color: #374151;
}

[dir] .pillRemove--KYSW5:hover {
  background: #e5e7eb;
}

.pillCloseIcon--TXE3R {
  width: 12px;
  height: 12px;
}

.noSelection--JyvTs {
  color: #6c757d;
  font-style: italic;
}

.modalActions--KiAWq {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

[dir] .modalActions--KiAWq {
  margin-top: 20px;
}

@media (max-width: 480px) {
  .modalActions--KiAWq {
    flex-direction: column;
  }

  .modalActions--KiAWq button {
    width: 100%;
    box-sizing: border-box;
  }
}

.cancelButton--Toyta {
  color: #e6512d;
  font-size: 16px;
  font-weight: 600;
  transition: all 0.15s;
  display: flex;
  align-items: center;
  justify-content: center;
}

[dir] .cancelButton--Toyta {
  padding: 9px 40px;
  border: 1px solid #e6512d;
  background: transparent;
  border-radius: 40px;
  cursor: pointer;
}

.cancelButton--Toyta:hover {
  color: white;
}

[dir] .cancelButton--Toyta:hover {
  background: #e6512d;
}

.deleteButton--EHQiO {
  color: white;
  font-size: 16px;
  font-weight: 600;
  transition: background 0.15s;
  display: flex;
  align-items: center;
  justify-content: center;
}

[dir] .deleteButton--EHQiO {
  padding: 9px 40px;
  border: 1px solid #e6512d;
  background: #e6512d;
  border-radius: 40px;
  cursor: pointer;
}

[dir] .deleteButton--EHQiO:hover {
  background: #e6512d;
}

[dir] .deleteButton--EHQiO:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.saveButton--MeKGl {
  color: white;
  font-size: 16px;
  font-weight: 600;
  transition: background 0.15s;
  display: flex;
  align-items: center;
  justify-content: center;
}

[dir] .saveButton--MeKGl {
  padding: 9px 40px;
  border: 1px solid #e6512d;
  background: #e6512d;
  border-radius: 40px;
  cursor: pointer;
}

[dir] .saveButton--MeKGl:hover {
  background: #d1451f;
}

[dir] .saveButton--MeKGl:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.deleteFromEditButton--JAsK3 {
  color: #dc2626;
  font-size: 16px;
  font-weight: 600;
  transition: all 0.15s;
}

[dir] .deleteFromEditButton--JAsK3 {
  padding: 9px 24px;
  border: 1px solid #dc2626;
  background: transparent;
  border-radius: 40px;
  cursor: pointer;
}

[dir=ltr] .deleteFromEditButton--JAsK3 {
  margin-right: auto;
}

[dir=rtl] .deleteFromEditButton--JAsK3 {
  margin-left: auto;
}

.deleteFromEditButton--JAsK3:hover {
  color: white;
}

[dir] .deleteFromEditButton--JAsK3:hover {
  background: #dc2626;
}

.errorMessage--FENIV {
  color: #dc2626;
  font-size: 16px;
}

[dir] .errorMessage--FENIV {
  margin-top: 12px;
}

.selectedCountriesInfo--Whf7N {
  font-size: 16px;
  color: #6b7280;
}

[dir] .selectedCountriesInfo--Whf7N {
  margin-top: 8px;
}

.countryCount--F3cZN {
  color: #333;
  font-weight: 500;
}

#custom-groups-tooltip {
  max-width: 90vw;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/CustomGroupsManager/styles.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EAER,mBAAmB;AACrB;;AANA;EAIE,kBAAkB;AAEpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AAGrB;;AALA;EAIE,YAAY;AACd;;AALA;EAGE,gBAAgB;AAElB;;AALA;EAGE,iBAAgB;AAElB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EAEE,WAAW;EAIX,eAAe;EAIf,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAdA;EACE,mBAAmB;EAEnB,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EAEjB,eAAe;EACf,kBAAkB;EAClB,eAAe;AAKjB;;AAEA;EAGE,gBAAgB;EAChB,WAAW;AACb;;AALA;EACE,SAAS;EACT,UAAU;AAGZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EAMnB,QAAQ;AACV;;AAVA;EAIE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAE3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EAIE,kBAAkB;EAClB,WAAW;EAGX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;EAER,kBAAkB;EAClB;;;oBAGkB,EAAE,6BAA6B,EACN,6BAA6B;EACxE,gBAAgB,EAAE,6BAA6B;EAC/C,uBAAuB;AACzB;;AArBA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;EAGjB,eAAe;EAMf,kBAAkB;EAMlB,yCAAyC;AAG3C;;AArBA;EAOE,gBAAgB;AAclB;;AArBA;EAOE,iBAAgB;AAclB;;AAEA;EACE,wDAAwD;EACxD,uBAAuB;EAEvB,WAAW;EACX,qBAAqB;AACvB;;AANA;EAGE,2BAA2B;AAG7B;;AAEA;EACE,yEAAyE;EAIzE,iBAAiB;EACjB,WAAW,EACU,yBAAyB;AAChD;;AARA;EAEE,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;AAIpB;;AARA;EAOE,mBAAmB;AACrB;;AARA;EAOE,kBAAmB;AACrB;;AAEA;EAGE,WAAW;EACX,qBAAqB;AACvB;;AALA;EACE,mBAAmB;EACnB,qBAAqB;AAGvB;;AAEA,kEAAkE;AAClE;EACE,WAAW;EACX,kBAAkB;EAElB,QAAQ;EAER,WAAW;EACX,YAAY;EAEZ,qDAA+Q;EAC/Q,6CAAuQ;EACvQ,oBAAoB;AACtB;AAZA;EAKE,2BAA2B;EAG3B,iCAAiC;AAInC;AAZA;EAGE,UAAU;AASZ;AAZA;EAGE,SAAU;AASZ;;AAEA;EACE,OAAO;EACP,iEAAiE;EACjE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;;EAME,eAAe;EACf,YAAY;EAEZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAdA;EAEE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EAGf,kBAAkB;AAMpB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EAGZ,oBAAiB;KAAjB,iBAAiB;EAEjB,kBAAkB;AACpB;;AARA;EAGE,kBAAkB;EAClB,uBAAuB;AAIzB;;AARA;EAME,iBAAiB;AAEnB;;AARA;EAME,kBAAiB;AAEnB;;AAEA;EACE,cAAc;AAChB;;AAFA;EACE,eAAc;AAChB;;AAEA;EAEE,eAAe;EACf,cAAc;EACd,gBAAgB;AAKlB;;AATA;EAKE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AATA;EACE,gBAAgB;AAQlB;;AATA;EACE,iBAAgB;AAQlB;;AAEA;EACE,eAAe;EACf,MAAM;EAGN,SAAS;EAET,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EAEb,sBAAsB;AACxB;;AAbA;EAME,8BAA8B;EAK9B,aAAa;AAEf;;AAbA;EAGE,OAAO;EACP,QAAQ;AASV;;AAbA;EAGE,QAAO;EACP,OAAQ;AASV;;AAEA;EAIE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AATA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;AAMpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EAEE,gBAAgB;AAClB;;AAHA;EACE,kBAAkB;AAEpB;;AAEA;EACE,cAAc;EACd,eAAe;AAEjB;;AAJA;EAGE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AAEzB;;AALA;EAIE,mBAAmB;AACrB;;AAEA;EAEE,WAAW;EACX,OAAO;AAET;;AALA;EACE,SAAS;AAIX;;AALA;EAIE,kBAAkB;AACpB;;AALA;EAIE,iBAAkB;AACpB;;AAEA;EAME,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;;sBAEoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;AAChB;;AAfA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,kBAAkB;AAUpB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EAEd,gBAAgB;EAChB,WAAW;AACb;;AALA;EAEE,kBAAkB;AAGpB;;AAEA;EACE,WAAW;EAIX,eAAe;AACjB;;AANA;EAEE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AAEpB;;AAEA;EACE,aAAa;AAGf;;AAJA;EAEE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAKlB;;AAPA;EAGE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EAGnB,eAAe;AACjB;;AANA;EAGE,cAAc;EACd,eAAe;AAEjB;;AAEA;EACE,iBAAiB;AACnB;;AAFA;EACE,gBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EAGZ,oBAAiB;KAAjB,iBAAiB;AACnB;;AANA;EAGE,kBAAkB;AAGpB;;AANA;EAIE,iBAAiB;AAEnB;;AANA;EAIE,gBAAiB;AAEnB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EAIX,eAAe;EACf,sBAAsB;AACxB;;AAPA;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AAGpB;;AAEA;EAGE,aAAa;AACf;;AAJA;EACE,qBAAqB;EACrB,6BAA6B;AAE/B;;AAEA;EAKE,eAAe;AACjB;;AANA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAE3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AAEV;;AALA;EAIE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EAKnB,eAAe;EACf,WAAW;EAEX,qBAAqB;AACvB;;AAXA;EAGE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAIlB,yCAAyC;AAE3C;;AAXA;EAME,wBAAwB;AAK1B;;AAXA;EAME,wBAAwB;AAK1B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EAGZ,oBAAiB;KAAjB,iBAAiB;AACnB;;AANA;EAGE,kBAAkB;AAGpB;;AANA;EAIE,iBAAiB;AAEnB;;AANA;EAIE,gBAAiB;AAEnB;;AAEA;EACE,gBAAgB;AAElB;;AAHA;EAEE,iBAAiB;AACnB;;AAHA;EAEE,gBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EAMvB,4BAA4B;EAC5B,cAAc;AAChB;;AAXA;EAIE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;AAGpB;;AAEA;EAEE,cAAc;AAChB;;AAHA;EACE,mBAAmB;AAErB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AAEV;;AALA;EAIE,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,sBAAsB;EACxB;AACF;;AAEA;EAIE,cAAc;EAGd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAbA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,uBAAuB;EAEvB,mBAAmB;EACnB,eAAe;AAOjB;;AAEA;EAEE,YAAY;AACd;;AAHA;EACE,mBAAmB;AAErB;;AAEA;EAIE,YAAY;EAGZ,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAbA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EAEnB,mBAAmB;EACnB,eAAe;AAOjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EAIE,YAAY;EAGZ,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAbA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EAEnB,mBAAmB;EACnB,eAAe;AAOjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EAIE,cAAc;EAGd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AAEvB;;AAXA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,uBAAuB;EAEvB,mBAAmB;EACnB,eAAe;AAKjB;;AAXA;EAUE,kBAAkB;AACpB;;AAXA;EAUE,iBAAkB;AACpB;;AAEA;EAEE,YAAY;AACd;;AAHA;EACE,mBAAmB;AAErB;;AAEA;EACE,cAAc;EACd,eAAe;AAEjB;;AAJA;EAGE,gBAAgB;AAClB;;AAEA;EAEE,eAAe;EACf,cAAc;AAChB;;AAJA;EACE,eAAe;AAGjB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".customGroupsContainer {\n  width: 100%;\n}\n\n.customGroupsSection {\n  margin-top: 32px;\n  padding-top: 16px;\n  border-top: 1px solid #e5e7eb;\n}\n\n.customGroupsTitleRow {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 8px;\n  white-space: nowrap;\n}\n\n.customGroupsTitle {\n  font-weight: 600;\n  color: #222;\n}\n\n.infoTooltip {\n  display: inline-flex;\n  align-items: center;\n  margin-left: 6px;\n  cursor: help;\n}\n\n.infoIcon {\n  width: 17px;\n  height: 17px;\n}\n\n.addCustomGroupButton {\n  background: #e6512d;\n  color: #fff;\n  border: none;\n  border-radius: 999px;\n  padding: 8px 22px;\n  font-size: 1rem;\n  cursor: pointer;\n  margin-bottom: 8px;\n  margin-top: 4px;\n  transition: background 0.15s;\n  font-weight: 600;\n  white-space: normal;\n  height: auto !important;\n}\n\n.customGroupsList {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  color: #444;\n}\n\n.customGroupItem {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px;\n  margin-bottom: 4px;\n  background: #f8f9fa;\n  border-radius: 4px;\n  border: 1px solid #e9ecef;\n  gap: 8px;\n}\n\n.customGroupItem:hover {\n  background: #e9ecef;\n}\n\n.customGroupName {\n  background: #fff;\n  border: 1.5px solid #d1d5db;\n  padding: 8px 12px;\n  font-size: inherit;\n  color: #333;\n  cursor: pointer;\n  text-align: left;\n  flex-grow: 1;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border-radius: 4px;\n  position: relative;\n  transition:\n    background 0.15s,\n    border 0.15s,\n    box-shadow 0.15s; /* align with .squareButton */\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03); /* align with .squareButton */\n  font-weight: 500; /* align with .squareButton */\n  height: auto !important;\n}\n\n.customGroupName:hover {\n  /* Match hover feel used in LocationPickerMenu buttons */\n  /*background: #b5b5b5;*/\n  border: 1.5px solid #343c42;\n  color: #222;\n  text-decoration: none;\n}\n\n.customGroupName.selected {\n  /* Match selected state used for countries/groups in LocationPickerMenu */\n  background: #ccced0;\n  border: 1.5px solid #343c42;\n  border-radius: 4px;\n  font-weight: bold;\n  color: #222;\n  padding-right: 24px; /* space for close icon */\n}\n\n.customGroupName.selected:hover {\n  background: #b5b5b5;\n  border-color: #343c42;\n  color: #222;\n  text-decoration: none;\n}\n\n/* Decorative close (x) like LocationPickerMenu; non-interactive */\n.customGroupName.selected::after {\n  content: '';\n  position: absolute;\n  right: 6px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 18px;\n  height: 18px;\n  background: rgba(52, 60, 66, 0.5);\n  -webkit-mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgZGF0YS1zdmc9ImNsb3NlIj48cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiNGNDkxMDMiIHN0cm9rZS13aWR0aD0iMi4wNiIgZD0iTTE2IDE2IDQgNE0xNiA0IDQgMTYiLz48L3N2Zz4=');\n  mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgZGF0YS1zdmc9ImNsb3NlIj48cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiNGNDkxMDMiIHN0cm9rZS13aWR0aD0iMi4wNiIgZD0iTTE2IDE2IDQgNE0xNiA0IDQgMTYiLz48L3N2Zz4=');\n  pointer-events: none;\n}\n\n.groupNameText {\n  flex: 1;\n  /* Allow long custom group names to wrap similar to .squareText */\n  white-space: normal;\n  overflow: visible;\n  text-overflow: clip;\n}\n\n.editIcon {\n  width: 16px;\n  height: 16px;\n  color: #e6512d;\n}\n\n.customGroupActions {\n  display: flex;\n  gap: 8px;\n}\n\n.customGroupEdit,\n.customGroupDelete {\n  background: none;\n  border: none;\n  padding: 8px;\n  cursor: pointer;\n  font-size: 16px;\n  opacity: 0.7;\n  border-radius: 4px;\n  min-width: 36px;\n  min-height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.customGroupEdit:hover,\n.customGroupDelete:hover {\n  opacity: 1;\n}\n\n.deleteIcon {\n  width: 18px;\n  height: 18px;\n  color: #e6512d;\n}\n\n.groupFlagPreview {\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n\n.previewFlag {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  border: 2px solid white;\n  object-fit: cover;\n  margin-left: -8px;\n  position: relative;\n}\n\n.previewFlag:first-child {\n  margin-left: 0;\n}\n\n.moreCountriesIndicator {\n  margin-left: 4px;\n  font-size: 12px;\n  color: #6b7280;\n  font-weight: 500;\n  background: #f3f4f6;\n  padding: 2px 6px;\n  border-radius: 10px;\n  border: 1px solid #d1d5db;\n}\n\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 16px;\n  box-sizing: border-box;\n}\n\n.modalContent {\n  background: white;\n  padding: 24px;\n  border-radius: 8px;\n  max-width: 500px;\n  width: 100%;\n  max-height: 80vh;\n  overflow-y: auto;\n  box-sizing: border-box;\n}\n\n.confirmBody {\n  font-size: 16px;\n  color: #333;\n}\n\n.confirmBody p {\n  margin: 0 0 12px 0;\n  line-height: 1.5;\n}\n\n.confirmDetails {\n  color: #6b7280;\n  font-size: 16px;\n  margin: 0;\n}\n\n.modalHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 16px;\n}\n\n.modalContent h3 {\n  margin: 0;\n  color: #333;\n  flex: 1;\n  padding-right: 8px;\n}\n\n.closeButton {\n  background: none;\n  border: 1px solid #d1d5db;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition:\n    background-color 0.15s,\n    border-color 0.15s;\n  width: 40px !important;\n  height: 40px !important;\n  flex-shrink: 0;\n}\n\n.closeButton:hover {\n  background-color: #f3f4f6;\n  border-color: #9ca3af;\n}\n\n.closeIcon {\n  width: 20px;\n  height: 20px;\n  color: #6b7280;\n}\n\n.formGroup {\n  margin-bottom: 16px;\n}\n\n.formGroup label {\n  display: block;\n  margin-bottom: 4px;\n  font-weight: 600;\n  color: #333;\n}\n\n.input {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 16px;\n}\n\n.input:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n}\n\n.countrySelector {\n  max-height: 200px;\n  overflow-y: auto;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  padding: 8px;\n  background: #f8f9fa;\n}\n\n.countryCheckbox {\n  display: flex;\n  align-items: center;\n  padding: 6px 0;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.countryCheckbox input {\n  margin-right: 8px;\n}\n\n.countryFlag {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  margin-right: 8px;\n  object-fit: cover;\n}\n\n.countryName {\n  flex: 1;\n}\n\n.customGroupSearchWrapper {\n  margin-bottom: 12px;\n}\n\n.customGroupSearchInput {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  font-size: 16px;\n  box-sizing: border-box;\n}\n\n.customGroupSearchInput:focus {\n  border-color: #2563eb;\n  box-shadow: 0 0 0 2px #dbeafe;\n  outline: none;\n}\n\n.selectedCountries {\n  padding: 12px;\n  background: #f8f9fa;\n  border-radius: 4px;\n  border: 1px solid #dee2e6;\n  font-size: 16px;\n}\n\n.selectedCountriesLabel::after {\n  content: ': ';\n}\n\n.selectedCountriesPills {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 6px;\n}\n\n.countryPill {\n  display: flex;\n  align-items: center;\n  background: #f9fafb;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  padding: 3px 4px 3px 6px;\n  font-size: 14px;\n  color: #222;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);\n  transition: all 0.15s;\n}\n\n.countryPill:hover {\n  background: #e5e7eb;\n  border-color: #9ca3af;\n}\n\n.pillFlag {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  margin-right: 5px;\n  object-fit: cover;\n}\n\n.pillText {\n  font-weight: 500;\n  margin-right: 3px;\n}\n\n.pillRemove {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 1px;\n  border-radius: 2px;\n  transition: background 0.15s;\n  color: #6b7280;\n}\n\n.pillRemove:hover {\n  background: #e5e7eb;\n  color: #374151;\n}\n\n.pillCloseIcon {\n  width: 12px;\n  height: 12px;\n}\n\n.noSelection {\n  color: #6c757d;\n  font-style: italic;\n}\n\n.modalActions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 20px;\n}\n\n@media (max-width: 480px) {\n  .modalActions {\n    flex-direction: column;\n  }\n\n  .modalActions button {\n    width: 100%;\n    box-sizing: border-box;\n  }\n}\n\n.cancelButton {\n  padding: 9px 40px;\n  border: 1px solid #e6512d;\n  background: transparent;\n  color: #e6512d;\n  border-radius: 40px;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 600;\n  transition: all 0.15s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.cancelButton:hover {\n  background: #e6512d;\n  color: white;\n}\n\n.deleteButton {\n  padding: 9px 40px;\n  border: 1px solid #e6512d;\n  background: #e6512d;\n  color: white;\n  border-radius: 40px;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 600;\n  transition: background 0.15s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.deleteButton:hover {\n  background: #e6512d;\n}\n\n.deleteButton:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n}\n\n.saveButton {\n  padding: 9px 40px;\n  border: 1px solid #e6512d;\n  background: #e6512d;\n  color: white;\n  border-radius: 40px;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 600;\n  transition: background 0.15s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.saveButton:hover {\n  background: #d1451f;\n}\n\n.saveButton:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n}\n\n.deleteFromEditButton {\n  padding: 9px 24px;\n  border: 1px solid #dc2626;\n  background: transparent;\n  color: #dc2626;\n  border-radius: 40px;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 600;\n  transition: all 0.15s;\n  margin-right: auto;\n}\n\n.deleteFromEditButton:hover {\n  background: #dc2626;\n  color: white;\n}\n\n.errorMessage {\n  color: #dc2626;\n  font-size: 16px;\n  margin-top: 12px;\n}\n\n.selectedCountriesInfo {\n  margin-top: 8px;\n  font-size: 16px;\n  color: #6b7280;\n}\n\n.countryCount {\n  color: #333;\n  font-weight: 500;\n}\n\n:global(#custom-groups-tooltip) {\n  max-width: 90vw;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"customGroupsContainer": `customGroupsContainer--g9hlF`,
	"customGroupsSection": `customGroupsSection--SaNSQ`,
	"customGroupsTitleRow": `customGroupsTitleRow--KFmjc`,
	"customGroupsTitle": `customGroupsTitle--pjZ49`,
	"infoTooltip": `infoTooltip--bFwrE`,
	"infoIcon": `infoIcon--Ja00b`,
	"addCustomGroupButton": `addCustomGroupButton--NNfAW`,
	"customGroupsList": `customGroupsList--R2a_3`,
	"customGroupItem": `customGroupItem--u8PPK`,
	"customGroupName": `customGroupName--CLkpU`,
	"selected": `selected--mZPMz`,
	"groupNameText": `groupNameText--mxyi6`,
	"editIcon": `editIcon--af2l0`,
	"customGroupActions": `customGroupActions--GOUtZ`,
	"customGroupEdit": `customGroupEdit--bQzqd`,
	"customGroupDelete": `customGroupDelete--8dSs4`,
	"deleteIcon": `deleteIcon--wAZ44`,
	"groupFlagPreview": `groupFlagPreview--B1mCX`,
	"previewFlag": `previewFlag--EOASZ`,
	"moreCountriesIndicator": `moreCountriesIndicator--XF3Ln`,
	"modal": `modal--PDwDq`,
	"modalContent": `modalContent--tzRxt`,
	"confirmBody": `confirmBody--J63FU`,
	"confirmDetails": `confirmDetails--FWxQw`,
	"modalHeader": `modalHeader--ImTr0`,
	"closeButton": `closeButton--_3jsl`,
	"closeIcon": `closeIcon--ydjno`,
	"formGroup": `formGroup--CcVPJ`,
	"input": `input--ihMSA`,
	"countrySelector": `countrySelector--nIjkE`,
	"countryCheckbox": `countryCheckbox--YTrKj`,
	"countryFlag": `countryFlag--fsfUW`,
	"countryName": `countryName--qlB4r`,
	"customGroupSearchWrapper": `customGroupSearchWrapper--mhKSi`,
	"customGroupSearchInput": `customGroupSearchInput--xsKDt`,
	"selectedCountries": `selectedCountries--iZMVT`,
	"selectedCountriesLabel": `selectedCountriesLabel--cvB8H`,
	"selectedCountriesPills": `selectedCountriesPills--E3pxi`,
	"countryPill": `countryPill--uqZv3`,
	"pillFlag": `pillFlag--M0S1i`,
	"pillText": `pillText--KGrAe`,
	"pillRemove": `pillRemove--KYSW5`,
	"pillCloseIcon": `pillCloseIcon--TXE3R`,
	"noSelection": `noSelection--JyvTs`,
	"modalActions": `modalActions--KiAWq`,
	"cancelButton": `cancelButton--Toyta`,
	"deleteButton": `deleteButton--EHQiO`,
	"saveButton": `saveButton--MeKGl`,
	"deleteFromEditButton": `deleteFromEditButton--JAsK3`,
	"errorMessage": `errorMessage--FENIV`,
	"selectedCountriesInfo": `selectedCountriesInfo--Whf7N`,
	"countryCount": `countryCount--F3cZN`
};
export default ___CSS_LOADER_EXPORT___;
